'use strict';

const { hydrate } = require('@grpn/hydration');

const Carousel = require('./carousel');

module.exports = hydrate('Carousel', Carousel);
